import React, { useState } from "react";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import dataService from "../services/dataService";


const ElolegSzamla = () => {
    const { order } = useOrder();
    const [loading, setLoading] = useState(false);
    const navigate = useStepNavigate();

    function handleSaveAndNavigate() {
        setLoading(true);
        dataService.saveOrder(order)
            .then(() => {
                navigate("/MeretlapNyomtatas");
            })
            .catch((error) => {
                console.error("Hiba az order mentésekor:", error);
                setLoading(false);
            });
    }

return (
    <TablerLayout>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h2>Előleg Számla</h2>
                </div>
            </div>
        </div>
        <div className="card-footer d-flex justify-content-between">
            <StepperNavButton
                side="left"
                label="Vissza"
                onClick={() => navigate("/MeretlapNyomtatas")}
            />
            <StepperNavButton
                side="right"
                label="Tovább"
                onClick={handleSaveAndNavigate}
                // disabled={!allFilled || loading}
            />
        </div>
    </TablerLayout>
        );
};
export default ElolegSzamla;